import { render, staticRenderFns } from "./channel-types-tabs.vue?vue&type=template&id=77e49d55&"
import script from "./channel-types-tabs.vue?vue&type=script&lang=ts&"
export * from "./channel-types-tabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports